import React from "react";

function Cabana() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M21.6667 30H18.3334V26.6667H21.6667V30ZM25 23.3333H15V33.3333H25V23.3333ZM31.6667 15.5L26.6667 11L20 5L3.33337 20H8.33337L20 9.48333L31.6667 20H36.6667L31.6667 15.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Cabana;
